import { render } from "./PaiceMcpServer.vue?vue&type=template&id=5d4d9a1a&scoped=true"
import script from "./PaiceMcpServer.vue?vue&type=script&lang=js"
export * from "./PaiceMcpServer.vue?vue&type=script&lang=js"

import "./PaiceMcpServer.vue?vue&type=style&index=0&id=5d4d9a1a&scoped=true&lang=css"
import "./PaiceMcpServer.vue?vue&type=style&index=1&id=5d4d9a1a&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4d9a1a"]])

export default __exports__